/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  WorkOSIntentOptions,
  WorkOSIntentOptions$Outbound,
  WorkOSIntentOptions$outboundSchema,
} from "./workosintentoptions.js";

/**
 * WorkOS Admin Portal intent.
 */
export const Intent = {
  Dsync: "dsync",
  Sso: "sso",
  AuditLogs: "audit_logs",
  DomainVerification: "domain_verification",
  LogStreams: "log_streams",
} as const;
/**
 * WorkOS Admin Portal intent.
 */
export type Intent = ClosedEnum<typeof Intent>;

export type GenerateWorkOSAdminPortalLinkRequestBody = {
  /**
   * WorkOS Admin Portal intent.
   */
  intent: Intent;
  intentOptions?: WorkOSIntentOptions | undefined;
  /**
   * IT contact email addresses displayed in the Admin Portal for end-user support.
   */
  itContactEmails?: Array<string> | undefined;
  /**
   * URL to redirect the user to after the Admin Portal session ends.
   */
  returnUrl?: string | undefined;
  /**
   * URL to redirect the user to on successful completion of the Admin Portal flow.
   */
  successUrl?: string | undefined;
};

/** @internal */
export const Intent$outboundSchema: z.ZodMiniEnum<typeof Intent> = z.enum(
  Intent,
);

/** @internal */
export type GenerateWorkOSAdminPortalLinkRequestBody$Outbound = {
  intent: string;
  intent_options?: WorkOSIntentOptions$Outbound | undefined;
  it_contact_emails?: Array<string> | undefined;
  return_url?: string | undefined;
  success_url?: string | undefined;
};

/** @internal */
export const GenerateWorkOSAdminPortalLinkRequestBody$outboundSchema:
  z.ZodMiniType<
    GenerateWorkOSAdminPortalLinkRequestBody$Outbound,
    GenerateWorkOSAdminPortalLinkRequestBody
  > = z.pipe(
    z.object({
      intent: Intent$outboundSchema,
      intentOptions: z.optional(WorkOSIntentOptions$outboundSchema),
      itContactEmails: z.optional(z.array(z.string())),
      returnUrl: z.optional(z.string()),
      successUrl: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        intentOptions: "intent_options",
        itContactEmails: "it_contact_emails",
        returnUrl: "return_url",
        successUrl: "success_url",
      });
    }),
  );

export function generateWorkOSAdminPortalLinkRequestBodyToJSON(
  generateWorkOSAdminPortalLinkRequestBody:
    GenerateWorkOSAdminPortalLinkRequestBody,
): string {
  return JSON.stringify(
    GenerateWorkOSAdminPortalLinkRequestBody$outboundSchema.parse(
      generateWorkOSAdminPortalLinkRequestBody,
    ),
  );
}
